document.addEventListener('DOMContentLoaded', function (event) {
	const btn = document.querySelector('.main-blog .js-load-more');
	if (btn !== null) {
		btn.addEventListener('click', (e) => {
			e.preventDefault();
			if (!btn.classList.contains('is-loading')) {
				btn.classList.add('is-loading');
				fetch(btn.getAttribute('href'), {
					method: 'GET',
					credentials: 'same-origin',
				})
					.then(function (response) {
						if (response.status !== 200) {
							const error = new Error(response.description);
							error.isFromServer = true;
							throw error;
						}
						return response.text();
					})
					.then((data) => {
						const parser = new DOMParser();
						const doc = parser.parseFromString(data, 'text/html');
						const list = doc.querySelector('.js-blog-list');

						if (list != null) {
							const listCurrent = document.querySelector('.js-blog-list');
							const items = list.querySelectorAll('.js-blog-list-item');
							items.forEach((el) => {
								el.classList.add('is-not-show');
								listCurrent.appendChild(el);
								setTimeout(() => {
									el.classList.remove('is-not-show');
								}, 10);
							});
							const loadMore = doc.querySelector('.js-load-more');
							if (loadMore == null) {
								btn.closest('.js-load-more-holder').remove();
							} else {
								btn.setAttribute('href', loadMore.getAttribute('href'));
							}
						}
						btn.classList.remove('is-loading');
					})
					.catch(function () {
						btn.classList.remove('is-loading');
					});
			}
		});
	}
	const sl = document.querySelector('.js-blog-navigation');
	let initialIndex = 0;
	const activeEl = document.querySelector('.js-blog-navigation .blog-navigation__item--current');
	if (activeEl != null) {
		initialIndex = parseInt(activeEl.getAttribute('data-index'));
	}
	if (sl != null) {
		new Flickity(sl, {
			prevNextButtons: false,
			pageDots: false,
			contain: true,
			initialIndex: initialIndex,
		});
	}
});
